import { InjectionToken } from '@angular/core';

import { GridType } from './core/template-definition.model';
import { GridTab } from './main-page/grid-tab.model';

export const CMPS_SCORECARD_WIDGET = new InjectionToken(
    'CMPS_SCORECARD_WIDGET',
);

/** @deprecated TODO revise. see usages. this could be grouped into an object, but keep separate for now */
export const CMPS_SCORECARD_PAGE = new InjectionToken<number>(
    'CMPS_SCORECARD_PAGE',
);

/** @deprecated TODO revise. see usages. this could be grouped into an object, but keep separate for now */
export const CMPS_SCORECARD_INITIAL_GRID_TAB = new InjectionToken<
    () => GridTab
>('CMPS_SCORECARD_INITIAL_GRID_TAB');

/** @deprecated TODO revise. see usages. this could be grouped into an object, but keep separate for now */
export const CMPS_SCORECARD_INITIAL_GRID_TYPE = new InjectionToken<
    () => GridType
>('CMPS_SCORECARD_INITIAL_GRID_TYPE');
